import { useEffect, useRef } from "react";

import { useBreakouts } from "../breakouts";

import { useTimeRemaining } from "./use-time-remaining";

interface UseBreakoutEndObserverProps {
  breakoutSessionEndsAt: string | null | undefined;
}

export const useBreakoutEndObserver = ({ breakoutSessionEndsAt }: UseBreakoutEndObserverProps) => {
  const breakoutEndDate = breakoutSessionEndsAt ? new Date(breakoutSessionEndsAt) : null;
  const { timeRemainingMs } = useTimeRemaining(breakoutEndDate);
  const { onEndBreakouts } = useBreakouts();
  const previousTimeRemainingMs = useRef<number | null>(null);

  const timeToEndTheBreakoutHasPassed =
    previousTimeRemainingMs.current !== null && timeRemainingMs === null;

  useEffect(() => {
    previousTimeRemainingMs.current = timeRemainingMs;
  }, [timeRemainingMs]);

  useEffect(() => {
    if (timeToEndTheBreakoutHasPassed) onEndBreakouts();
  }, [timeToEndTheBreakoutHasPassed, onEndBreakouts]);
};
